@if (useStandard) {
  <crm-standard-multi-select
    [descriptorApiUrl]="descriptorUrl"
    [selectedValues]="unitIds !== null ? null : selectedUnits"
    [selectedKeys]="unitIds"
    (selectedValuesChange)="onSelected($event)"
    [filtersUiVersion]="filtersUiVersion"
    [labelInput]="isFloatLabel"
    labelInputText="Бизнес единица"
    [placeholder]="placeholder"
    [display]="display"
    [showClear]="showClear"
    [class]="class"
    [styleClass]="styleClass"
    [itemStyleClass]="itemStyleClass"
    [disabled]="disabled"
    [isError]="isError"
    [appendTo]="appendTo"></crm-standard-multi-select>
} @else {
  <crm-multi-select
    [filtersUiVersion]="filtersUiVersion"
    [styleClass]="styleClass"
    [class]="class"
    [label]="isFloatLabel ? 'Бизнес единица' : ''"
    [showClear]="showClear"
    [appendTo]="appendTo"
    [options]="units"
    [disabled]="disabled"
    [display]="display"
    [sort]="sort"
    [placeholder]="placeholder"
    [itemStyleClass]="itemStyleClass"
    [isError]="isError"
    [selectedItems]="selectedUnits"
    (selectedItemsChange)="onSelected($event)"
    [loading]="loading || selectionLoading"></crm-multi-select>
}
